import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import Layout from '../../components/Layout';
import { Creators as AppCreators } from '../../redux/reducers/app';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setClientPlataform: AppCreators.setClientPlataform,
    },
    dispatch
  );

const mapStateToProps = ({ app }) => ({
  template: app.getIn(['config', 'theme', 'template'], 'A'),
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
